// extracted by mini-css-extract-plugin
export default {"Navigation":"Navbar_Navigation__-2L4K"};